export const EXCEL_EXPORT_ACTION_ID = 'excelExport';
export const EXCEL_ADD_ACTION_ID = 'excelAdd';
export const EXCEL_EDIT_ACTION_ID = 'excelEdit';
